import { useCallback, useMemo } from 'react';
import { get } from 'lodash';
import { useEntityType } from 'hooks/useEntityType';
import { useChatAgentContext } from './useChatAgentContext';

export const useChatAgentRecommendation = field => {
    const { agentRecommendations, removeRecommendation } = useChatAgentContext();
    const entityType = useEntityType();

    const value = useMemo(
        () => get(agentRecommendations, `${entityType}.${field}`),
        [agentRecommendations, entityType, field]
    );

    const remove = useCallback(() => removeRecommendation(field), [removeRecommendation, field]);

    return {
        value,
        remove,
    };
};
